// // File Location: src/services/authService.js

// import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
// import { doc, setDoc, getDoc } from 'firebase/firestore';
// import { auth, db } from './firebaseConfig';

// // User roles
// export const USER_ROLES = {
//   SUPER_ADMIN: 'SuperAdmin',
//   HOSPITAL: 'Hospital',
//   DOCTOR: 'Doctor',
//   POLICY_WRITER: 'PolicyWriter',
//   FINANCIAL_TEAM: 'FinancialTeam'
// };

// // Login function
// export const loginUser = async (email, password) => {
//   try {
//     const userCredential = await signInWithEmailAndPassword(auth, email, password);
//     const user = userCredential.user;
    
//     // Fetch user data from Firestore
//     const userDoc = await getDoc(doc(db, 'users', user.uid));
//     if (userDoc.exists()) {
//       return {
//         success: true,
//         user: user,
//         userData: userDoc.data()
//       };
//     } else {
//       throw new Error('User data not found');
//     }
//   } catch (error) {
//     return {
//       success: false,
//       error: error.message
//     };
//   }
// };

// // Register function (mainly for admin to create users)
// export const registerUser = async (email, password, userData) => {
//   try {
//     const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//     const user = userCredential.user;
    
//     // Save user data to Firestore
//     await setDoc(doc(db, 'users', user.uid), {
//       uid: user.uid,
//       email: email,
//       ...userData,
//       createdAt: new Date(),
//       isActive: true
//     });
    
//     return {
//       success: true,
//       user: user
//     };
//   } catch (error) {
//     return {
//       success: false,
//       error: error.message
//     };
//   }
// };

// // Create user document in Firestore
// export const createUserDocument = async (uid, userData) => {
//   try {
//     await setDoc(doc(db, 'users', uid), {
//       uid,
//       ...userData,
//       createdAt: new Date(),
//       isActive: true
//     });
//     return { success: true };
//   } catch (error) {
//     return { success: false, error: error.message };
//   }
// };
// File Location: src/services/authService.js

import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebaseConfig';

// User roles
export const USER_ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  SYSTEM_ADMIN: 'SystemAdmin',
  HOSPITAL: 'Hospital',
  DOCTOR: 'Doctor',
  POLICY_WRITER: 'PolicyWriter',
  FINANCIAL_TEAM: 'FinancialTeam',
  LEAD_GENERATOR: 'LeadGenerator'
};

// Login function
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Fetch user data from Firestore
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (userDoc.exists()) {
      return {
        success: true,
        user: user,
        userData: userDoc.data()
      };
    } else {
      throw new Error('User data not found');
    }
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

// Register function (mainly for admin to create users)
export const registerUser = async (email, password, userData) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Save user data to Firestore
    await setDoc(doc(db, 'users', user.uid), {
      uid: user.uid,
      email: email,
      ...userData,
      createdAt: new Date(),
      isActive: true
    });
    
    return {
      success: true,
      user: user
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

// Create user document in Firestore
export const createUserDocument = async (uid, userData) => {
  try {
    await setDoc(doc(db, 'users', uid), {
      uid,
      ...userData,
      createdAt: new Date(),
      isActive: true
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Helper function to get dashboard route based on user role
export const getRoleDashboardRoute = (role) => {
  switch (role) {
    case USER_ROLES.SUPER_ADMIN:
      return "/admin/dashboard";
    case USER_ROLES.SYSTEM_ADMIN:
      return "/system-admin/dashboard";
    case USER_ROLES.HOSPITAL:
      return "/hospital/dashboard";
    case USER_ROLES.DOCTOR:
      return "/doctor/dashboard";
    case USER_ROLES.POLICY_WRITER:
      return "/policy/dashboard";
    case USER_ROLES.FINANCIAL_TEAM:
      return "/finance/dashboard";
    case USER_ROLES.LEAD_GENERATOR:
      return "/lead-generator/dashboard";
    default:
      return "/dashboard";
  }
};